import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiMinus } = FiIcons;

export default function TimerAdjuster({ onIncrement, onDecrement }) {
  return (
    <div className="flex flex-col gap-1.5 ml-4 self-center">
      <button
        onClick={onIncrement}
        title="+5 Min"
        className="
          flex items-center justify-center
          min-h-[44px] min-w-[44px]
          w-10 h-10
          rounded-lg
          bg-[#131313] border border-[#252525]
          text-[#555555]
          hover:bg-[#202020] hover:border-[#3a3a3a] hover:text-white
          active:scale-95 active:bg-[#2a2a2a]
          transition-all duration-100
        "
      >
        <SafeIcon icon={FiPlus} className="w-3.5 h-3.5" />
      </button>

      <button
        onClick={onDecrement}
        title="-5 Min"
        className="
          flex items-center justify-center
          min-h-[44px] min-w-[44px]
          w-10 h-10
          rounded-lg
          bg-[#131313] border border-[#252525]
          text-[#555555]
          hover:bg-[#202020] hover:border-[#3a3a3a] hover:text-white
          active:scale-95 active:bg-[#2a2a2a]
          transition-all duration-100
        "
      >
        <SafeIcon icon={FiMinus} className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}